/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable camelcase */
/* eslint-disable new-cap */
import { net } from 'zf-web-infra';
import dingtalk from 'dingtalk-jsapi';
import type * as Types from '../types';

export class DingTalkLoginService {

  private readonly OPTIONS = {
    id: 'login-qrcode',
    width: '100%',
    height: 300
  };

  async init(tenant: string, config: Types.DingtalkLoginSettingResponse): Promise<IDTLoginSuccess> {
    return await new Promise(resolve => {
      window.DTFrameLogin(
        {
          id: this.OPTIONS.id,
          width: this.OPTIONS.width,
          height: this.OPTIONS.height
        },
        {
          redirect_uri: this.getRedirctUrl(tenant),
          client_id: config.appKey,
          scope: 'openid+corpid',
          response_type: 'code',
          state: 'dingtalkQRLogin',
          prompt: 'consent',
          corpId: config.corpId
        },
        async loginResult => {
          resolve(loginResult);
        },
        errorMsg => {
          console.log('dingtalkLogin errorMsg:', errorMsg);
        }
      );
    });
  }

  async fetchConfig(params: { tenant: string; app: string }): Promise<Types.DingtalkLoginSettingResponse> {
    return await net.get<Types.DingtalkLoginSettingResponse>('/api/account/dingtalkQRLoginSetting', params);
  }

  async login(params: Types.DingtalkLoginParams): Promise<Types.LoginResponse> {
    return await net.post<Types.LoginResponse>('/api/account/dingtalkQRLogin', params);
  }

  /**
   * 在钉钉环境中则尝试自动登录
   * @returns
   */
  async autoLogin(params: { tenant: string; app: string }): Promise<Types.LoginResponse | undefined> {
    try {
      const { tenant, app } = params;
      const config = await this.fetchConfig({ tenant, app });

      if (dingtalk.env.version == null) {
        return;
      }
      if (config?.appKey == null || config?.corpId == null) {
        return;
      }
      const { code } = await dingtalk.runtime.permission.requestAuthCode({ corpId: config.corpId });

      return await net.post<Types.LoginResponse>('/api/account/dingtalkAutoLogin', { tenant, authCode: code });
    } catch (error) {
      console.error('dingtalk auto login error:', error);
      return;
    }
  }

  private getRedirctUrl(tenant: string): string {
    return encodeURIComponent(`${window.location.origin}/login?tenant=${tenant}&type=dingtalk`);
  }

}

